import { Tab } from '@starsoft/common/src/components/Tabs/Tab/props';
import { PeriodTabsOptions } from '@/enums/filter-by-period';

export const gameDetailsPeriodFilterOptions: Array<Tab<PeriodTabsOptions>> = [
  {
    label: '1day_filter',
    value: PeriodTabsOptions.OneDay,
  },
  {
    label: '3days_filter',
    value: PeriodTabsOptions.ThreeDays,
  },
  {
    label: '7days_filter',
    value: PeriodTabsOptions.OneWeek,
  },
];
